import { Router } from "@frui.ts/screens";
import { attachAutomaticValidator } from "@frui.ts/validation";
import { computed } from "mobx";
import EnumRepository from "repositories/enumRepository";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import { Modules, newNavigationName } from "config";
import Road, { RoadValidationRules } from "entities/road";
import RoadType from "entities/roadType";
import OptionsService from "services/optionsService";
import CreateViewModel from "viewModels/createViewModel";

@Router.registerRoute({ name: Router.Self, route: newNavigationName })
export default class RoadCreateViewModel extends CreateViewModel<Road> {
  readonly modelName = "road";

  @computed
  get roadTypes() {
    return this.optionsService.internalEnumOptions(RoadType);
  }

  constructor(
    protected repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected optionsService: OptionsService,
    protected eventBus: EventBus
  ) {
    super();
    this.navigationName = newNavigationName;
  }

  protected loadDetail(): Promise<Road> | Road {
    const entity = new Road();
    attachAutomaticValidator(entity, RoadValidationRules);
    return entity;
  }

  protected postData() {
    return this.repository.create(this.item, "roads");
  }

  translate(code: string, size: number | undefined): string {
    return this.localizationService.translateModule(Modules.timeCharges, `roads.${code}`, size);
  }
}
